import { useTheme } from '@mui/material/styles';
import { SearchResult } from 'functions/src/types/firestore/Search';
import { ImageOptimized } from 'src/components/image/ImageOptimized';
import { CryptoChain } from 'src/util/CryptoChain';
import { SearchResultBase } from './SearchResultBase';

export type ItemSearchResultProps = SearchResult & { category: 'item' };

export const ItemSearchResult = ({
  item,
  objectID,
  title,
  description,
}: ItemSearchResultProps) => {
  const [chainId, contractAddress, itemId] = objectID.split('-');
  const chain = CryptoChain.from(chainId);
  const theme = useTheme();
  return (
    <SearchResultBase
      href={`/item/${chain.coin.toLowerCase()}/${contractAddress}/${itemId}`}
      imageSx={{
        display: 'flex',
        flexGrow: 0,
        minWidth: 90,
        minHeight: 90,
        backgroundImage: `linear-gradient(${
          theme.palette.background.elevationSolid[23]
        },
        ${theme.palette.background.elevationSolid[23]}), ${
          item.rarity
            ? theme.palette.rarityBackground[item.rarity]
            : 'linear-gradient(180deg, #4DC8FF 0%, #0064E9 100%)'
        }`,
        backgroundOrigin: 'border-box',
        backgroundClip: 'content-box, border-box',
        border: '1px double transparent',
        borderRadius: '4px',
      }}
      image={
        <ImageOptimized
          src={item.imgUrl}
          alt=""
          width={90}
          height={90}
          style={{ borderRadius: '4px' }}
        />
      }
      header={`${title} #${itemId}`}
      subHeader={item.rarity}
      subHeaderColor={`rarity.${item.rarity}`}
      description={description}
      category="Item"
      // chevronColor={
      //   item.rarity !== 'common'
      //     ? `rarityBackground.${toCamelCase(item.rarity)}`
      //     : undefined
      // }
    />
  );
};
